
import React, { useContext, useEffect, useState } from 'react';
import ConnUrls from '../../Connections/ConnectURL';
import { MasterContext } from '../../ContextApi/context';
import BigPopUpMsg from '../BigPopUpMsg';
import PopUpMsg from '../PopUpMsg';


const No_TakeAway = (props) => {

    const [master] = useContext(MasterContext);

    return (

            <BigPopUpMsg
            class={"oops"}
            imgSrc={`${ConnUrls.servMediasUrl}${master.oopsPopImg}`}
            Title={["ללא איסופים!"]}
            ContentText={["המסעדה לא מקבלת",
                "הזמנות איסופים כרגע"]}
            inLabel={""}
            okClick={() => props.okClick()}
            BtnTxt={"חזור"}
            BtnTxt2={"עבור לעמוד המסעדה"}
            btnClick2={() => props.btnClick2()}
            errorMsg={""} />
    )
}


export default No_TakeAway;